import { render, staticRenderFns } from "./document8.vue?vue&type=template&id=7e148ba9&"
import script from "./document8.vue?vue&type=script&lang=ts&"
export * from "./document8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports